export const giftWithPurchaseQueryKeys = {
    all: () => ['gift-with-purchase'] as const,

    lists: () => [...giftWithPurchaseQueryKeys.all(), 'list'] as const,
    list: (params: { ownerId: number; search: string }) =>
        [...giftWithPurchaseQueryKeys.lists(), params] as const,

    details: () => [...giftWithPurchaseQueryKeys.all(), 'detail'] as const,
    detail: (id: number) => [...giftWithPurchaseQueryKeys.details(), id] as const,

    tierGiftsSearches: () => [...giftWithPurchaseQueryKeys.all(), 'tier-gifts-search'] as const,
    tierGiftsSearch: (params: { search: string; excludedIds: string }) =>
        [...giftWithPurchaseQueryKeys.tierGiftsSearches(), params] as const,

    productSearches: () => [...giftWithPurchaseQueryKeys.all(), 'product-search'] as const,
    productSearch: (params: Partial<{ search: string; offset: number; limit: number }>) =>
        [...giftWithPurchaseQueryKeys.productSearches(), params] as const,
}
